module.exports = __webpack_public_path__ + "img/montage-icon-blue.640e98a2.svg";